/**
 * The value each flag falls back to when the Remote Config template has no parameter for it —
 * a fresh environment, or a flag added to the app before it was added to the template.
 *
 * Also the canonical list of what *is* a flag: `setConfigFlags` reads exactly these keys, and
 * the Dev Tools panel lists and pins exactly these keys. Extracted from `FlagsActions` so the
 * panel can name a flag without importing the module that owns the Firebase connection.
 *
 * Typed as `Record<string, string>` rather than Firebase's own `defaultConfig` type, which also
 * admits numeric keys — `Object.keys` on it hands back `(string | number)[]` and every consumer
 * has to launder it back into a flag name.
 */
export const defaultFlags: Record<string, string> = {
  id_verification_show_tag_provider: 'false',
  product_order_types: '[]',
  dts_moud_pilot: '[]',
  pdmp_pilot: '[]',
  pdmp_integrated_states: '[]',
  adyen: '{"enabled":false,"only_enabled_for_users_created_after":null}',
  provider_google_sso: 'true',
  sentry_feedback_provider: '{"active":false,"emails":[]}',
  async_refills_phase_1: 'false',
  pharmacy_search_daw: 'false',
  daw_show_treat_and_add: '[]',
  unified_token_refresh: 'false',
  // Kill switch for the Kratom / 7-OH support-plan badge (QMD-4145). Provider's
  // own key rather than patient-web's `program_dashboard_enabled`, matching the
  // `id_verification_show_tag_provider` precedent: clinicians and patients are
  // separate audiences and get turned on separately.
  program_visit_badge_provider: 'false',
  // PRJ-578: shows the UI-only live-visit mock (made-up medication answers in place of the intake
  // form, and a made-up Home Delivery preference). Not a Remote Config parameter: `FlagsActions`
  // never reads it from the template, so only a Dev Tools pin turns it on, and the override layer
  // is inert wherever production is served. Delete it together with `prj578LiveVisitMocks`.
  live_visit_hd_mock: 'false',
  // QMD-4694. Kill switch for the Iterable-driven dashboard announcement placement. Pausing the
  // campaign in Iterable turns off a *message*; this turns off *our rendering of it*, which is the
  // only lever that helps if a published announcement breaks the dashboard layout or throws.
  iterable_announcements_provider: 'false',
}
